var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCommentActiveInline = function SvgIconCommentActiveInline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-comment-active",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-repondre-active",
    d: "M422.911 85.1h-3a4.5 4.5 0 0 0-1 8.885V97.1l3.5-3h.5a4.5 4.5 0 0 0 0-9Z",
    transform: "translate(-415.411 -85.104)",
    fill: "currentColor"
  })));
};
export { SvgIconCommentActiveInline as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1jb21tZW50LWFjdGl2ZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgICA8cGF0aCBpZD0iaWNvbi1yZXBvbmRyZS1hY3RpdmUiIGQ9Ik00MjIuOTExLDg1LjFoLTNhNC41LDQuNSwwLDAsMC0xLDguODg1Vjk3LjFsMy41LTNoLjVhNC41LDQuNSwwLDAsMCwwLTlaIgogICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQxNS40MTEgLTg1LjEwNCkiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";